module.exports = __webpack_public_path__ + "img/NP.17659fdf.png";